import { getSessionJWT } from "@/infra/auth/helper";
import { safeEmit } from "@/infra/sockets";
import { useLoggedInMember } from "@/modules/auth/states";
import { addNotification } from "@/shared/states/notification";
import { useCallback, useEffect } from "react";
export const useSessionSubscription = (sessionId: string) => {
  const loggedInUser = useLoggedInMember();
  const emitSessionOpened = useCallback(() => {
    try {
      const EVENT_ID = "shared:doc:opened";

      if (!loggedInUser?.member_id) {
        console.warn('No user ID available');
        return;
      }
      const payload = {
        agent_session_id: sessionId,
        control_id: "None"
      };

      // biome-ignore lint/suspicious/noExplicitAny: <explanation>
      safeEmit(EVENT_ID, payload, (response: any) => {
        if (response?.error) {
          console.error('Error emitting session opened:', response.error);
          addNotification({
            type: 'error',
            message: 'Failed to sync session status'
          });
        }
      });
    } catch (error) {
      console.error('Error in emitSessionOpened:', error);
    }
  }, [sessionId, loggedInUser?.member_id]);
  useEffect(() => {
    if (loggedInUser?.member_id) {
      emitSessionOpened();
    }
  }, [emitSessionOpened, loggedInUser?.member_id]);
};